import { render } from "./HDRShulkRework.vue?vue&type=template&id=d10fe060&scoped=true"
import script from "./HDRShulkRework.vue?vue&type=script&lang=js"
export * from "./HDRShulkRework.vue?vue&type=script&lang=js"

import "./HDRShulkRework.vue?vue&type=style&index=0&id=d10fe060&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d10fe060"]])

export default __exports__